import { t } from "../lib/sprache";

/**
 * Verständlichkeitsprüfung 30.10.2026 (Muster 1): Knöpfe, die eine Mail auslösen oder nicht umkehrbar sind, sagen das, und
 * davor steht eine Rückfrage mit einem Satz zur Folge. Die Texte stehen hier an einer Stelle, damit Generator und
 * Rechnungsdetail denselben Schritt gleich benennen („endgültig erstellen“ statt „festschreiben“, C2-01).
 */
export type Rueckfrage = { title: string; text: string; confirmLabel: string; danger?: boolean };

/** Knopf zum Festschreiben einer Rechnung bzw. Gutschrift (C2-01); `mitSpeichern` im Generator */
export function endgueltigKnopf(gutschrift: boolean, mitSpeichern = false): string {
  if (gutschrift) return mitSpeichern
    ? t("Speichern, endgültig erstellen und an den Creator senden", "Save, issue and send to the creator")
    : t("Gutschrift endgültig erstellen und an den Creator senden", "Issue self-billing invoice and send to the creator");
  return mitSpeichern ? t("Speichern und endgültig erstellen", "Save and issue") : t("Rechnung endgültig erstellen", "Issue invoice");
}

/** Rückfrage vor dem Festschreiben (C2-01): Nummer, Unveränderlichkeit, wer etwas bekommt */
export function endgueltigFrage(o: { gutschrift: boolean; anCreator: boolean }): Rueckfrage {
  if (o.gutschrift) return {
    title: t("Gutschrift endgültig erstellen?", "Issue self-billing invoice?"),
    text: [
      t("Die Gutschrift bekommt jetzt ihre Nummer und lässt sich danach nicht mehr ändern, nur noch stornieren.", "The self-billing invoice now gets its number and can no longer be changed afterwards, only cancelled."),
      t("Der Creator bekommt sie sofort per Mail mit PDF und kann im Portal widersprechen.", "The creator receives it by email with PDF straight away and can object in the portal."),
    ].join("\n"),
    confirmLabel: t("Endgültig erstellen und senden", "Issue and send"),
  };
  return {
    title: t("Rechnung endgültig erstellen?", "Issue invoice?"),
    text: [
      t("Die Rechnung bekommt jetzt ihre Nummer und lässt sich danach nicht mehr ändern, nur noch stornieren.", "The invoice now gets its number and can no longer be changed afterwards, only cancelled."),
      o.anCreator
        ? t("An den Creator geht noch nichts; das Senden ist der nächste Schritt.", "Nothing is sent to the creator yet; sending is the next step.")
        : t("An die Marke geht noch nichts; das Senden ist der nächste Schritt.", "Nothing is sent to the brand yet; sending is the next step."),
    ].join("\n"),
    confirmLabel: t("Endgültig erstellen", "Issue"),
  };
}

/** Satz unter einer Warnung, die schon „Trotzdem endgültig erstellen“ anbietet (dann keine zweite Rückfrage) */
export function endgueltigFolge(gutschrift: boolean): string {
  return gutschrift
    ? t("Danach ist die Gutschrift unveränderlich und geht sofort per Mail an den Creator.", "Afterwards the self-billing invoice is unchangeable and goes to the creator by email straight away.")
    : t("Danach ist die Rechnung unveränderlich und lässt sich nur noch stornieren. Gesendet wird erst im nächsten Schritt.", "Afterwards the invoice is unchangeable and can only be cancelled. It is sent only in the next step.");
}

/** Verständlichkeit B-04: Angebot fertigstellen (früher „festschreiben“); gesendet wird erst im nächsten Schritt */
export function angebotFertigFrage(): Rueckfrage {
  return {
    title: t("Angebot fertigstellen?", "Finalise offer?"),
    text: [
      t("Das Angebot bekommt jetzt seine Nummer und lässt sich danach nicht mehr ändern. Änderungen gehen dann nur noch über eine neue Fassung.", "The offer now gets its number and can no longer be changed afterwards. Changes are then only possible with a new version."),
      t("Gesendet wird erst im nächsten Schritt; dort wählst du, wer es bekommt.", "It is sent only in the next step, where you choose who receives it."),
    ].join("\n"),
    confirmLabel: t("Fertigstellen", "Finalise"),
  };
}
